export default {"src":"/_next/static/media/leeks.6ff70bc2.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};